import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Toaster = _resolveComponent("Toaster")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isConnected ? _ctx.layout : _ctx.layoutWithoutNav), null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    })),
    (_ctx.hasErrorActive)
      ? (_openBlock(), _createBlock(_component_Toaster, {
          key: 0,
          message: _ctx.toasterMessage
        }, null, 8, ["message"]))
      : _createCommentVNode("", true)
  ], 64))
}